/**
 * Extracts a JSON object or array from text that may contain prose before/after.
 * Handles LLM responses like "You're right. Here is the update:\n\n{ ... }" by
 * stripping the prose and returning only the parseable JSON substring.
 */
export function extractJsonFromText(text: string): string | null {
  const objStart = text.indexOf("{");
  const arrStart = text.indexOf("[");
  const start =
    objStart === -1 ? arrStart
    : arrStart === -1 ? objStart
    : Math.min(objStart, arrStart);
  if (start === -1) return null;

  const open = text[start] === "{" ? "{" : "[";
  const close = open === "{" ? "}" : "]";
  const s = text.slice(start);
  let depth = 0;
  let inString = false;
  let escape = false;

  for (let i = 0; i < s.length; i++) {
    const c = s[i];
    if (escape) {
      escape = false;
      continue;
    }
    if (inString) {
      if (c === "\\") escape = true;
      else if (c === '"') inString = false;
      continue;
    }
    if (c === '"') {
      inString = true;
      continue;
    }
    if (c === open) {
      depth++;
      continue;
    }
    if (c === close) {
      depth--;
      if (depth === 0) {
        const candidate = s.slice(0, i + 1);
        try {
          JSON.parse(candidate);
          return candidate;
        } catch {
          return null;
        }
      }
    }
  }
  return null;
}
